

export enum EnumIndDesperdicio {
    NaoSeAplica = 0,
    NaoProduzido = 1,
    Produzido = 2,
    Consumido = 3
}